(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/services/assets/hooks/use-competition-mode-for-path.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/services/assets/hooks/use-competition-mode-for-path.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const _React = React,
  useEffect = _React.useEffect;
const _ReactRouterDOM = ReactRouterDOM,
  matchPath = _ReactRouterDOM.matchPath,
  useLocation = _ReactRouterDOM.useLocation;
const useCompetitionDispatcher = svs.components.marketplaceCompetition.services.hooks.useCompetitionDispatcher;

const useCompetitionModeForPath = (competitionId, productIds, competitionPaths, competitionStatus) => {
  const location = useLocation();
  const _useCompetitionDispat = useCompetitionDispatcher(competitionId, productIds),
    _useCompetitionDispat2 = _slicedToArray(_useCompetitionDispat, 3),
    hasCompetitions = _useCompetitionDispat2[0],
    dispatchCompetition = _useCompetitionDispat2[1],
    dispatchCompetitionClear = _useCompetitionDispat2[2];
  useEffect(() => {
    let cancel;
    const match = matchPath(location.pathname, {
      path: competitionPaths,
      exact: true,
      strict: false
    });
    if (match && competitionStatus) {
      dispatchCompetition();
      cancel = true;
    } else {
      dispatchCompetitionClear();
      cancel = false;
    }
    return () => {
      if (cancel) {
        dispatchCompetitionClear();
      }
    };
  }, [location.pathname, dispatchCompetition, dispatchCompetitionClear, competitionPaths, competitionStatus]);
  return hasCompetitions;
};
setGlobal('svs.components.marketplaceCompetition.services.hooks.useCompetitionModeForPath', useCompetitionModeForPath);

 })(window);